import { render, staticRenderFns } from "./Administration_ChocolateSharpener.vue?vue&type=template&id=a85943ae"
import script from "./Administration_ChocolateSharpener.vue?vue&type=script&lang=js"
export * from "./Administration_ChocolateSharpener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports